import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useStudentQuizGet = (levelId) => {
  const params = { associated_content_id: levelId };
  const queryString = new URLSearchParams(params).toString();
  const resource = `${MONOLITH_ORIGIN}/api/v3/studentquiz/?${queryString}`;
  return useRestQuery(resource, { skip: !levelId });
};

export default useStudentQuizGet;
